/** Selection metadata belongs on a component's visible DOM root. */
export type DomMetadata = {
  'data-pid'?: string;
  [name: `data-poneva-${string}`]: string | number | boolean | undefined;
};

export function splitDomMetadata<T extends object>(props: T) {
  const metadata: DomMetadata = {};
  const rest = { ...props };
  for (const key of Object.keys(props)) {
    if (key !== 'data-pid' && !key.startsWith('data-poneva-')) continue;
    (metadata as Record<string, unknown>)[key] = (props as Record<string, unknown>)[key];
    delete (rest as Record<string, unknown>)[key];
  }
  return { metadata, rest };
}
